const YouTubeMusicIcon = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 192 192"
    xmlns="http://www.w3.org/2000/svg"
    stroke="white"
    fill="currentColor"
  >
    <g id="XMLID_167_">
      <circle id="XMLID_791_" cx="96" cy="96" r="88" />
      <g id="XMLID_41_">
        <path
          id="XMLID_42_"
          fill="#FFFFFF"
          d="M96,54.04c23.14,0,41.96,18.82,41.96,41.96S119.14,137.96,96,137.96S54.04,119.14,54.04,96
			S72.86,54.04,96,54.04 M96,50c-25.41,0-46,20.59-46,46s20.59,46,46,46s46-20.59,46-46S121.41,50,96,50L96,50z"
        />
      </g>
      <polygon id="XMLID_274_" fill="#FFFFFF" points="80,119 119,95 80,73 	" />
    </g>
  </svg>
);

export default YouTubeMusicIcon;
